export const ACTION_CODE = 'PROJECTS' + '_ACTION';
